import styled from 'styled-components';

export const PickerRow = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
`;

export const PickerContainer = styled.div`
  flex: 1;
  > div {
    min-height: auto;
  }
`;

export const NoteSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  div {
    min-height: auto;
  }
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  font-weight: 600;
  font-size: 13px;
  color: #212529;
  &.margin {
    margin-bottom: 5px;
    align-items: flex-start;
  }
`;
export const NoteIcon = styled.img``;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
  width: 100%;
`;

const BaseButton = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
`;

export const CancelButton = styled(BaseButton)`
  background: #ffffff;
  color: #0a0a0a;
  border: 1px solid #0000001a;

  &:hover {
    background: #f8f9fa;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SubmitButton = styled(BaseButton)`
  background: linear-gradient(90deg, #2a75e8 0%, #1f406e 100%);
  color: #ffffff;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 13px;
  margin-top: 12px;
  padding: 8px 12px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
`;
